import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/reset/:token',
      name: 'reset-password',
      component: () => import('./views/reset')
    },
    {
      path: '/registrazione/:name',
      name: 'subscribe',
      component: () => import('./views/subscribe'),
    },
    {
      path: '/',
      name: 'home',
      component: () => import('./views/home'),
    },
    {
      path: '/api/status-update/',
      name: 'status-update',
      component: () => import('./views/status-update'),
    },
    {
      path: '/demo',
      name: 'demo-form',
      component: () => import('./views/demo-form'),
    },
    {
      path: '/utenti',
      component: () => import('./views/utenti/layout'),
      children: [
        {
          path: '/',
          name: 'utenti.list',
          component: () => import('./views/utenti/list'),
        },
      ]
    },
    /*
    {
      path: '/centri',
      component: () => import('./views/centri/layout'),
      children: [
        {
          path: '/',
          name: 'centri.list',
          component: () => import('./views/centri/list'),
        },
      ]
    },*/

    {
      path: '/importazione',
      name: 'import',
      component: () => import('./views/import'),
    },
    {
      path: '/soci',
      component: () => import('./views/soci/layout'),
      children: [
        {
          path: '/',
          name: 'soci.list',
          component: () => import('./views/soci/list'),
        },
        {
          path: '/tessere',
          name: 'soci.cards',
          component: () => import('./views/soci/cards'),
        },
      ]
    },
    {
      path: '/contabilita',
      component: () => import('./views/contab/layout'),
      children: [
        {
          path: '/',
          name: 'contabilita.prima-nota',
          component: () => import('./views/contab/prima-nota'),
        },
        {
          path: '/fatture',
          name: 'contabilita.fatture',
          component: () => import('./views/contab/fatture'),
        },
        {
          path: '/scadenzario',
          name: 'contabilita.scadenzario',
          component: () => import('./views/contab/scadenzario'),
        },
        {
          path: '/bilancio',
          name: 'contabilita.bilancio',
          component: () => import('./views/contab/bilancio'),
        },
        {
          path: '/contatti',
          name: 'contabilita.contacts',
          component: () => import('./views/contab/contacts'),
        },
        {
          path: '/conti',
          name: 'contabilita.ledgers',
          component: () => import('./views/contab/ledgers'),
        },
        {
          path: '/iva',
          name: 'contabilita.iva',
          component: () => import('./views/contab/iva'),
        },
        {
          path: '/ops',
          name: 'contabilita.ops',
          component: () => import('./views/contab/ops'),
        },
        {
          path: '/inventory',
          name: 'contabilita.inventory',
          component: () => import('./views/contab/inventory'),
        },
      ]
    },
    {
      path: '/impostazioni',
      name: 'settings',
      component: () => import('./views/settings'),
    },
    {
      path: '/reload',
      name: 'reload',
      component: Vue.extend({
        render: (h) => h,
        mounted () { setTimeout(() => this.$router.back()) }
      })
    },
  ]
})
